export default {
  methods: {
    shipmentStatusColorFactory(status) {
      switch (status) {
        case 'Dispatch Booked':
          return 'warning';
        case 'Shipment Dispatched':
          return '#2FDD92';
        case 'Returned':
          return 'danger';
        case 'Customer Received':
          return '#34BE82';
        case 'Cancelled':
          return 'danger';

      }
    }
  }
}
